'use client';

import { APoint } from '@commerce-payment-webcomponents/ui';
import { CmsComponent, ModularBlockComponent } from '@commerce-webcomponents/ui-composite';
import { useSession } from '@nextgen-web-framework/all';
import useLivePreview from '../../../../live-preview/useLivePreview';
import { BannerComponentType, BasePageProps } from '../../../../types/common';
import Layout from 'app/components/Layout/Layout';
import withNextgenRoute from 'app/utils/withNextgenRoute';
import { TemplateType, getComponentStylesConfig } from 'utils/componentsStylingConfigs';

const APointCatalogPage = (props: BasePageProps) => {
  const { isMember } = useSession();
  const header = props?.data?.layout?.header;
  const footer = props?.data?.layout?.footer;
  const [pageData] = useLivePreview(props?.data, props?.seoData);
  const componentStylesConfig = getComponentStylesConfig(TemplateType.A_POINT_CATALOG_LANDING);
  const showAPointSummary = isMember();

  return (
    <Layout hasTopMobileHeader={true} header={header} footer={footer}>
      {pageData?.hero_section && (
        <CmsComponent componentKey={BannerComponentType.STANDARD_BANNER_WITH_NO_CTA} data={pageData?.hero_section} />
      )}
      {showAPointSummary && <APoint />}
      {pageData?.body_section && (
        <ModularBlockComponent data={pageData?.body_section} componentStylesConfig={componentStylesConfig} />
      )}
    </Layout>
  );
};

export default withNextgenRoute<BasePageProps>(APointCatalogPage);
